import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

interface CompleteOrPendClickedState {
  wasPendClaimClicked: boolean;
  wasCompleteClaimClicked: boolean;
}

const completeOrPendClickedInitialState: CompleteOrPendClickedState = {
  wasPendClaimClicked: false,
  wasCompleteClaimClicked: false,
};

export const completeOrPendClicked = createSlice({
  name: 'completeOrPendClicked',
  initialState: completeOrPendClickedInitialState,
  reducers: {
    togglePendTrue: (state) => {
      state.wasPendClaimClicked = !state.wasPendClaimClicked;
    },
    toggleCompleteTrue: (state) => {
      state.wasCompleteClaimClicked = !state.wasCompleteClaimClicked;
    },
  },
});

export const { togglePendTrue, toggleCompleteTrue } = completeOrPendClicked.actions;

export const selectWasClaimWorkflowSubmitted = (state: RootState) =>
  state.completeOrPendClicked.wasCompleteClaimClicked || state.completeOrPendClicked.wasPendClaimClicked;

export default completeOrPendClicked.reducer;
